import { Component, input } from '@angular/core';

@Component({
  selector: 'app-price-user',
  templateUrl: './price-user.component.html',
  styleUrl: './price-user.component.scss'
})
export class PriceUserComponent {
  input_price_usdValue = input.required<number>();
  input_price_tlValue = input.required<number>();
  input_type = input.required<String>();

}
